//const API_URL = "http://localhost:8080/api/admin";
const API_URL = "https://ngapi.firstfiddle.in/api/admin";

const endpoints = {
  API_URL: API_URL,
  apitoken: "",
  login: API_URL + "/login",
  franchiseFilter: API_URL + "/franchiseFilter",
  all_categoryFilter: API_URL + "/all-categoryFilter",
  rest_filter: API_URL + "/rest_filter",
  getFranchiseLeads: API_URL + "/getFranchiseLeads",
  top_customer: API_URL + "/top-customer",
  brand_status: API_URL + "/brand-status",
  getBrands: API_URL + "/get-brands",
  addBrands: API_URL + "/add-brand",
  updateBrand: API_URL + "/update-brand/",
  editBrand: API_URL + "/edit-brand/",
  deleteBrand: API_URL + "/delete-brand/",
  deleteBrandImage: API_URL + "/delete-brandimage/",

  popup_detail: API_URL + "/popup-detail",
  popup_list: API_URL + "/popup-list",
  updatePopup: API_URL + "/update-popup-detail",

  top_customer_filter: API_URL + "/top-customer-filter",
  getTopDishes: API_URL + "/getTopDishes",
  getRestaurentsInApp: API_URL + "/getRestaurentsInApp",

  res_servicelist: API_URL + "/restro_service",

  get_pr: API_URL + "/get_pr",
  add_pr: API_URL + "/add_pr",

  pr_status: API_URL + "/pr_status",

  menuData: API_URL + "/menuData",
  getContactUs: API_URL + "/getContactUs",
  getSubscribeUs: API_URL + "/getSubscribeUs",
  contactusFilter: API_URL + "/contactusFilter",

  uploadExcel: API_URL + "/uploadExcel",
  uploadmenu: API_URL + "/uploadMenu",

  //dashboardDataFilter api start
  getdashboardData: API_URL + "/dashboardData",
  getdashboardDatafilter: API_URL + "/dashboardDataFilter",

  //dashboardDataFilter api end

  getFreshSalesData: API_URL + "/getFreshSalesData",
  FreshsalesFilter: API_URL + "/FreshsalesFilter",
  update_booking_status: API_URL + "/update_booking_status",
  update_feedback_status: API_URL + "/update_feedback_status",
  appUserFilter: API_URL + "/appUserFilter",
  dishFilter: API_URL + "/dishFilter",
  categoryFilter: API_URL + "/categoryFilter",
  outerdishFilter: API_URL + "/outer_dish_filter",

  getAppUser: API_URL + "/getAppUser",
  menuFilter: API_URL + "/menuFilter",
  getOutlet: API_URL + "/getOutlet",
  editOutlet: API_URL + "/editOutlet",
  deleteOutlet: API_URL + "/deleteOutlet",
  addOutlet: API_URL + "/addOutlet",
  updateOutlet: API_URL + "/updateOutlet",
  deleteImageOutlet: API_URL + "/deleteImageOutlet",
  outlet_filter: API_URL + "/outlet_filter",

  //coming-soon outlet start
  addLotdCSoon: API_URL + "/addLotdCSoon",
  editLotdCSoon: API_URL + "/editLotdCSoon",
  updateLotdCSoon: API_URL + "/updateLotdCSoon",
  getLotdCSoon: API_URL + "/getLotdCSoon",
  deleteLotdCSoon: API_URL + "/deleteLotdCSoon",
  deleteImageLotdCSoon: API_URL + "/deleteImageLotdCSoon",
  //coming-soon outlet start
  //outlet-details start
  addOutletDetails: API_URL + "/add-outlet_detail",
  editOutletDetails: API_URL + "/editOutlet-details",
  updateOutletDetails: API_URL + "/updateOutlet-details",
  getOutletDetails: API_URL + "/getOutlet-details",
  deleteOutletDetails: API_URL + "/deleteOutlet-details",
  deleteOutletDetailsImage: API_URL + "/deleteimageOutlet-details",
  outletDetails_status: API_URL + "/outlet-details-status",

  //outlet-details end

  birthdayFilter: API_URL + "/birthdayFilter",
  app_webRestStatus: API_URL + "/app_webRestStatus",
  app_webSecRestStatus: API_URL + "/app_webSecRestStatus",
  reservationFilter: API_URL + "/reservationFilter",
  eventFilter: API_URL + "/eventFilter",

  getBooking: API_URL + "/getBooking",
  getRegistrationData: API_URL + "/getRegistrationData",
  getCustomerFeedback: API_URL + "/getCustomerFeedback",

  getBillScanReport: API_URL + "/getBillScanReport",
  editBill: API_URL + "/editBill",
  updateBill: API_URL + "/updateBill",

  getCategory: API_URL + "/getCategory",
  addCategory: API_URL + "/addCategory/",
  updateCategory: API_URL + "/updateCategory",
  deleteCategory: API_URL + "/deleteCategory/",
  editCategory: API_URL + "/editCategory/",
  deleteImageCat: API_URL + "/deleteImageCat/",
  deleteCategory: API_URL + "/deleteCategory/",

  editAbout: API_URL + "/editAbout/",
  deleteImageAbout: API_URL + "/deleteImageAbout/",
  updateAppAbout: API_URL + "/updateAppAbout",

  getSlider: API_URL + "/getSlider",
  addSlider: API_URL + "/addSlider/",
  updateSlider: API_URL + "/updateSlider",
  deleteSlider: API_URL + "/deleteSlider/",
  editSlider: API_URL + "/editSlider/",
  deleteSliderImage: API_URL + "/deleteSliderImage/",

  getHomeSlider: API_URL + "/getHomeSlider",
  addHomeSlider: API_URL + "/addHomeSlider/",
  updateHomeSlider: API_URL + "/updateHomeSlider",
  deleteHomeSlider: API_URL + "/deleteHomeSlider/",
  editHomeSlider: API_URL + "/editHomeSlider/",
  deleteHomeSliderImage: API_URL + "/deleteHomeSliderImage/",

  getDish: API_URL + "/getDish",
  addDish: API_URL + "/addDish/",
  updateDish: API_URL + "/updateDish",
  deleteDish: API_URL + "/deleteDish/",
  editDish: API_URL + "/editDish/",
  deleteImageDish: API_URL + "/deleteImageDish/",

  getRestaurentsAmenities: API_URL + "/getRestaurentsAmenities",
  addRestaurentsAmenities: API_URL + "/addRestaurentsAmenities/",
  updateRestaurentsAmenities: API_URL + "/updateRestaurentsAmenities",
  deleteRestaurentsAmenities: API_URL + "/deleteRestaurentsAmenities/",
  editRestaurentsAmenities: API_URL + "/editRestaurentsAmenities/",
  //   deleteImageDish: API_URL + "/deleteImageDish/",

  getRestaurentsDigitalMenu: API_URL + "/getRestaurentsDigitalMenu",
  addRestaurentsDigitalMenu: API_URL + "/addRestaurentsDigitalMenu/",
  updateRestaurentsDigitalMenu: API_URL + "/updateRestaurentsDigitalMenu",
  deleteRestaurentsDigitalMenu: API_URL + "/deleteRestaurentsDigitalMenu/",
  editRestaurentsDigitalMenu: API_URL + "/editRestaurentsDigitalMenu/",

  getTags: API_URL + "/getTags",
  addTag: API_URL + "/addTag/",
  updateTag: API_URL + "/updateTag",
  deleteTag: API_URL + "/deleteTag/",
  editTags: API_URL + "/editTags/",
  getDopdownTags: API_URL + "/getDopdownTags/",

  getTagsByDishID: API_URL + "/getTagsByDishID/",
  updateTagBYDishID: API_URL + "/updateTagBYDishID/",

  getDopdownCategory: API_URL + "/getDopdownCategory/",
  getDishDropdown: API_URL + "/getDishDropdown/",
  getRestaurentsDropDown: API_URL + "/getRestaurentsDropDown",
  getRestaurentsDropDownPosist: API_URL + "/getRestaurentsDropDownPosist",
  getCloneMenu: API_URL + "/cloneMenu",
  getRestaurents: API_URL + "/getRestaurents/",
  addRestaurents: API_URL + "/addRestaurents/",
  updateRestaurents: API_URL + "/updateRestaurents/",
  deleteRestaurents: API_URL + "/deleteRestaurents/",
  editRestaurents: API_URL + "/editRestaurents/",
  deleteImageRest: API_URL + "/deleteImageRest/",
  deleteImagePoint: API_URL + "/deleteImagePoint/",

  getRestaurentsAmenities: API_URL + "/getRestaurentsAmenities/",
  addRestaurentsAmenities: API_URL + "/addRestaurentsAmenities/",
  updateRestaurentsAmenities: API_URL + "/updateRestaurentsAmenities/",
  deleteRestaurentsAmenities: API_URL + "/deleteRestaurentsAmenities/",
  editRestaurentsAmenities: API_URL + "/editRestaurentsAmenities/",
  deleteImageAmenitiesRest: API_URL + "/deleteImageAmenitiesRest/",

  getRestaurentsDeals: API_URL + "/getRestaurentsDeals/",
  addRestaurentsDeals: API_URL + "/addRestaurentsDeals/",
  updateRestaurentsDeals: API_URL + "/updateRestaurentsDeals/",
  deleteRestaurentsDeals: API_URL + "/deleteRestaurentsDeals/",
  editRestaurentsDeals: API_URL + "/editRestaurentsDeals/",
  deleteImageDealRest: API_URL + "/deleteImageDealRest/",

  getRestaurentsMedia: API_URL + "/getRestaurentsMedia/",
  addRestaurentsMedia: API_URL + "/addRestaurentsMedia/",
  updateRestaurentsMedia: API_URL + "/updateRestaurentsMedia/",
  deleteRestaurentsMedia: API_URL + "/deleteRestaurentsMedia/",
  editRestaurentsMedia: API_URL + "/editRestaurentsMedia/",
  deleteImageMediaRest: API_URL + "/deleteImageMediaRest/",
  filterRestaurentsMedia: API_URL + "/filterRestaurentsMedia/",

  getRestaurentsMenu: API_URL + "/getRestaurentsMenu/",
  addRestaurentsMenu: API_URL + "/addRestaurentsMenu/",
  updateRestaurentsMenu: API_URL + "/updateRestaurentsMenu/",
  deleteRestaurentsMenu: API_URL + "/deleteRestaurentsMenu/",
  editRestaurentsMenu: API_URL + "/editRestaurentsMenu/",
  deleteImageMenuRest: API_URL + "/deleteImageMenuRest/",

  getSubCategory: API_URL + "/getSubCategory",
  addSubCategory: API_URL + "/addSubCategory/",
  updateSubCategory: API_URL + "/updateSubCategory",
  deleteSubCategory: API_URL + "/deleteSubCategory/",
  editSubCategory: API_URL + "/editSubCategory/",
  getDopdownSubCategory: API_URL + "/getDopdownSubCategory/",

  getTagsByTagType: API_URL + "/getTagsByTagType/",
  getMenuType: API_URL + "/getMenuType/",

  getSection: API_URL + "/getSection/",
  addSection: API_URL + "/addSection/",
  updateSection: API_URL + "/updateSection/",
  deleteSection: API_URL + "/deleteSection/",
  editSections: API_URL + "/editSections/",
  deleteSectionImage: API_URL + "/deleteSectionImage/",

  getEvents: API_URL + "/getEvents/",
  addEvent: API_URL + "/addEvent/",
  updateEvents: API_URL + "/updateEvents/",
  deleteEvents: API_URL + "/deleteEvents/",
  editEvents: API_URL + "/editEvents/",
  deleteImageEvent: API_URL + "/deleteImageEvent/",

  getPoints: API_URL + "/getPoints/",
  addPoint: API_URL + "/addPoint/",
  updatePoint: API_URL + "/updatePoint/",
  deletePoints: API_URL + "/deletePoints/",
  editPoints: API_URL + "/editPoints/",

  getPriceRange: API_URL + "/getPriceRange/",
  addPrice: API_URL + "/addPrice/",
  updatePrice: API_URL + "/updatePrice/",
  deletePrice: API_URL + "/deletePrice/",
  editPrice: API_URL + "/editPrice/",
  getPriceRangeDropDown: API_URL + "/getPriceRangeDropDown/",

  addUser: API_URL + "/addUser/",
  getUsers: API_URL + "/getUsers/",
  editUsers: API_URL + "/editUsers/",
  updateUsers: API_URL + "/updateUsers/",
  deleteUsers: API_URL + "/deleteUsers/",

  catupdateSorting: API_URL + "/catupdateSorting/",
  subcatupdateSorting: API_URL + "/subcatupdateSorting/",
  dishcatupdateSorting: API_URL + "/dishcatupdateSorting/",
  updateSectionSorting: API_URL + "/updateSectionSorting/",
  updateDishStatus: API_URL + "/updateDishStatus/",
  updateCatStatus: API_URL + "/updateCatStatus/",
  deleteSubCat: API_URL + "/deleteSubCategory/",

  updateSubCatStatus: API_URL + "/updateSubCatStatus/",
  deleteSection: API_URL + "/deleteSection/",

  getLoyality: API_URL + "/getloyality",
  getloyalitynbyid: API_URL + "/getloyalitynbyid",

  getPosistData: API_URL + "/getPosist",
  getPosistbyid: API_URL + "/getPosistbyid",
  getPosist: API_URL + "/getPosistbyidNew",

  whatsApp: API_URL + "/whatsApp",

  //paid reservation api
  addDayWise: API_URL + "/addDayWise",
  getDayWise: API_URL + "/getDayWise",
  updateDayWise: API_URL + "/updateDayWise",

  //menuhistory
  importHistory: API_URL + "/importHistory",
  importExcelHistory: API_URL + "/importExcelHistory",
  uploadmenunew: API_URL + "/uploadMenuNew",
};
export { endpoints };
